import type { ZipCodeLocationType } from '@widget/core';

export const formatMcSearchLink = (
  link: string | null | undefined,
  locationData: ZipCodeLocationType | null,
): string => {
  if (!link || !locationData) {
    return '';
  }

  return link.replace('__ID__', locationData.id || '').replace('__term__', locationData.name || '');
};
